module.exports = __webpack_public_path__ + "img/01.d253719b.jpg";